export type { PromotionQuoteProps } from './PromotionQuote.types';
export { default } from './PromotionQuote';
